// SPA entry — replaces the TanStack Start server/client entries
// (src/start.ts + src/server.ts, stripped per the ownership port).
// Everything below the router is the vendored Lovable app, verbatim.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import "./styles.css";

const router = getRouter();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
